import { render, staticRenderFns } from "./StudentModule.vue?vue&type=template&id=36f7194b"
import script from "./StudentModule.vue?vue&type=script&lang=js"
export * from "./StudentModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports